import type { ProviderType } from '../../../entities/provider';

export interface ProviderForm {
  name: string;
  key: string;
  type: ProviderType;
  actual: boolean;
  // data fields — keyed by type
  data_phone: string; // P1SMS: sender phone number
  data_sender: string; // P1SMS: sender name
}

export const EMPTY_PROVIDER_FORM: ProviderForm = {
  name: '',
  key: '',
  type: 'P1SMS',
  actual: true,
  data_phone: '',
  data_sender: '',
};

export const TYPE_OPTIONS: { value: ProviderType; label: string }[] = [
  { value: 'P1SMS', label: 'P1SMS' },
];

/** Extra fields per provider type */
export const TYPE_DATA_FIELDS: Record<ProviderType, { field: keyof ProviderForm; label: string; placeholder: string }[]> = {
  P1SMS: [{ field: 'data_phone', label: 'Номер телефона (отправитель)', placeholder: '+7 (___) ___-__-__' }],
};
